<div class="ui-dialog-container">
  <div class="ui-dialog-toolbar">
    <button mat-icon-button mat-dialog-close color="warn" aria-label="Close dialog" matTooltip="{{ 'btn.close' | translate }}">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="ui-dialog-content">
    <h4>{{ "pdf.questionnaire.export.title" | translate }} :</h4>
    <div class="btn-container">
      <ng-container *ngIf="data.context === PDF_TYPE_CONTEXT.QUESTIONNAIRE">
        <button
          mat-raised-button
          (click)="onExportOneQuestionnaireToPDF(false)"
          style="margin-right: 0.5em"
          [disabled]="exportPdfListInProgress || exportPdfTableInProgress"
        >
          {{ "pdf.questionnaire.export.list" | translate }}
          <mat-icon *ngIf="exportPdfListInProgress"><mat-spinner diameter="24"></mat-spinner></mat-icon>
        </button>
        <button
          mat-raised-button
          (click)="onExportOneQuestionnaireToPDF(true)"
          [disabled]="exportPdfListInProgress || exportPdfTableInProgress"
        >
          {{ "pdf.questionnaire.export.table" | translate }}
          <mat-icon *ngIf="exportPdfTableInProgress"><mat-spinner diameter="24"></mat-spinner></mat-icon>
        </button>
      </ng-container>

      <div *ngIf="data.context === PDF_TYPE_CONTEXT.CHARGE_ITEM" style="width: 200px">
        <mat-radio-group [(ngModel)]="selectedFormat" style="display: flex; flex-direction: column; gap: 2px">
          <mat-radio-button *ngFor="let format of exportFormats" [value]="format" class="mr-2">
            {{ format }}
          </mat-radio-button>
        </mat-radio-group>

        <div class="btn-container" style="margin-top: 1em">
          <ng-container *ngIf="loading; else sendText">
            <mat-spinner diameter="20"></mat-spinner>
          </ng-container>
          <ng-template #sendText>
            <button mat-raised-button color="primary" (click)="onExportChargeItems()" [disabled]="!selectedFormat || loading">
              {{ "btn.download" | translate }}
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
